export const putScheduleInitialState = {
	schedules: null,
	error: null,
	errorShow: false,
	loading: false,
};
	